import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoriesPage from "@/pages/categories/page";
import CategoryDetailPage from "@/pages/categories/SlugPage";
import ArticlesPage from "@/pages/articles/page";
import ArticleDetailPage from "@/pages/articles/SlugPage";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/categories/:slug",
    element: <CategoryDetailPage />,
  },
  {
    path: "/articles",
    element: <ArticlesPage />,
  },
  {
    path: "/articles/:slug",
    element: <ArticleDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;